module.exports = __webpack_public_path__ + "static/william-2-a09f523915c2e8b34b54cd51ada763b0.png";